<template>
  <div class="mp-grid" :class="{ 'is-5': columns === 5 }">
    <MarketTemplateCard
      v-for="id in ids"
      :key="id"
      :template-id="id"
      :hot="hot"
      @preview="(tid) => emit('preview', tid)"
      @use="(tid) => emit('use', tid)"
    />
    <div v-if="!ids.length" class="mp-grid__empty">该分类暂无模板</div>
  </div>
</template>

<script lang="ts" setup>
import MarketTemplateCard from './MarketTemplateCard.vue'

defineOptions({ name: 'MarketTemplateGrid' })

withDefaults(
  defineProps<{
    ids: number[]
    hot?: boolean
    columns?: 5 | 6
  }>(),
  { columns: 6, hot: false }
)

const emit = defineEmits<{
  preview: [id: number]
  use: [id: number]
}>()
</script>

<style lang="scss" scoped>
.mp-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 16px;

  &.is-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  &__empty {
    color: #b0b3ba;
    font-size: 13px;
    padding: 30px 0;
    text-align: center;
    grid-column: 1 / -1;
  }
}
</style>
